/**
 * 通知私信相关
 */
import request from "../utils/request";

/**
 * 获取消息未读数量
 * https://yapi.gaoding.com/project/1536/interface/api/118464
 */
export function getUnreadNum() {
  return request({
    url: "/message/unreads",
    ignoreError: true,
    ignoreMessage: true,
  }).catch((err) => {
    // 如果获取失败，返回 0
    console.error(err);
    return 0;
  });
}

/**
 * 获取消息列表
 * https://yapi.gaoding.com/project/1536/interface/api/118423
 * @param {*} query
 * @returns
 */
export function getMessage(query) {
  return request({
    url: "/message",
    query,
  });
}

/**
 * 获取未读私信
 * https://yapi.gaoding.com/project/1536/interface/api/118457
 */
export function getDmUnread() {
  return request({
    url: "/dm/unreads",
    ignoreError: true,
    ignoreMessage: true,
  });
}

/**
 * 获取对话列表
 * https://yapi.gaoding.com/project/1536/interface/api/118430
 * @typedef {{
 *    to_user_id: number,
 *    system_dm_id: number,
 *    text: string,
 *    created_at: number
 * }} systemCon
 *
 * @typedef {{
 *  blocked?: 0|1,
 *  conversation_id: number,
 *  hidden?: 0|1,
 *  last_message?: {
 *    from_user_id: number,
 *    text: string,
 *    to_user_id: number,
 *    type: "sent"|"received"
 * }
 *  with_user_id: number,
 *  with_user: IUser;
 * updated_at?: number
 * }} Conversation
 * @param {{
 *  limit: number, max?: number
 * }}
 * @returns {Promise<{err: any, conversations: (Conversation|systemCon)[]}>}
 */
export function getConversationList({ limit, max }) {
  return request({
    url: "/dm",
    query: { limit, max },
  });
}

/**
 * 获取系统通知列表
 * https://yapi.gaoding.com/project/1536/interface/api/118436
 * @returns {Promise<any|undefined>}
 */
export function getSystemDMList() {
  return request({
    url: "/system_dm",
  });
}

/**
 * 获取 聊天消息列表
 * https://yapi.gaoding.com/project/1536/interface/api/118449
 * @param {number} with_user_id
 * @param {number=} since
 * @param {number=} max
 * @param {number=} limit
 * @returns {Promise<*|undefined>}
 */
export function getMessageList({ with_user_id, since, max, limit }) {
  return request({
    url: `/dm/messages/${with_user_id}`,
    query: {
      since,
      max,
      limit,
    },
  });
}

/**
 * 发送 聊天信息
 * https://yapi.gaoding.com/project/1536/interface/api/118429
 * @param to_user_id
 * @param text
 * @returns {Promise<any|undefined>}
 */
export function sendMessage({ to_user_id, text }) {
  return request({
    method: "post",
    url: "/dm/send",
    data: { to_user_id, text },
    ignoreMessage: true,
  });
}

/**
 * 设置 会话 为已读
 * https://yapi.gaoding.com/project/1536/interface/api/118486
 * @param with_user_id
 * @returns {Promise<any|undefined>}
 */
export function setMessageReaded({ with_user_id }) {
  return request({
    url: "/dm/read",
    query: { with_user_id },
  });
}

/**
 * 设置系统消息为已读
 * https://yapi.gaoding.com/project/1536/interface/api/118463
 * @returns {Promise<any|undefined>}
 */
export function setSystemDMReaded() {
  return request({
    url: "/system_dm/read_all",
  });
}

/**
 * 获取最新的系统消息
 * @returns
 */
export function getLatestSystemDM() {
  return request({
    url: "/system_dm/lastest",
  });
}

/**
 * 设置 会话 全部已读
 * https://yapi.gaoding.com/project/1536/interface/api/118486
 * @param with_user_id
 * @returns {Promise<any|undefined>}
 */
export function setDMAllReaded() {
  return request({
    url: "/dm/read_all",
  });
}

/**
 * 删除私信会话
 * @param {number} with_user_id
 * @returns {Promise<any|undefined>}
 * https://yapi.gaoding.com/project/1536/interface/api/118486
 */
export function deleteConversation({ with_user_id }) {
  return request({
    method: "post",
    url: "/dm/hide",
    data: { user_id: with_user_id },
  });
}
